import React from "react";
import "./style.sass";
import assets from '../../assets'
import { LatexRenderer } from "../latex-renderer";

export const AdminRoundResult = ({ data }) => {
  const players =
    data?.leaderboard?.map((item, index) => ({
      id: index,
      name: item.nickname,
      score: item.score,
      rank: index + 1,
    })) || [];

  return (
    <section className="modal">
      {/* Header */}
      <section className="modal-header">
        <p className="round-result-txt">Round Result</p>
      </section>

      {/* Correct Answer */}
      <section className="correct-answer">
        <p className="label">CORRECT ANSWER</p>
        <section className="answer-box">
          <span className="badge-res"><LatexRenderer text={data?.correct_answer} inline /></span>
          <p><LatexRenderer text={data?.correct_text} inline /></p>
        </section>
      </section>

      {/* Table Header */}
      <section className="table-header">
        <span>RANK</span>
        <span>PLAYER</span>
        <span>SCORE</span>
      </section>

      {/* Player List */}
      <section className="player-list">
        {players.map((player) => (
          <section
            key={player.id}
            className={`player-card-res ${player.rank === 1 ? "top" : ""}`}
          >
            <section className="rank-res">{player.rank}</section>

            <section className="player-info">
              <img src={assets.ic_chats_avatar} alt="" />
              <span className="name">
                {player.name}
                {player.isYou && <span className="you-badge">YOU</span>}
              </span>
            </section>

            <section
              className={`score-res ${player.rank === 1 ? "top-color" : ""}`}
            >
              {player.score}
            </section>
          </section>
        ))}
      </section>

      {/* Footer */}
      <section className="footer-text">Next Question Coming Up...</section>
    </section>
    // </section>
  );
};
